const trimTrailingSlash = (value) => (value ? value.replace(/\/+$/, '') : value)

export const getApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.__PUPU_API_BASE__) {
    return trimTrailingSlash(window.__PUPU_API_BASE__)
  }

  return trimTrailingSlash(process.env.VUE_APP_API_BASE_URL || '/api')
}

export const getFrontendBaseUrl = () => {
  if (typeof window !== 'undefined' && window.__PUPU_FRONTEND_BASE__) {
    return trimTrailingSlash(window.__PUPU_FRONTEND_BASE__)
  }

  if (process.env.VUE_APP_FRONTEND_BASE_URL) {
    return trimTrailingSlash(process.env.VUE_APP_FRONTEND_BASE_URL)
  }

  if (typeof window === 'undefined') {
    return ''
  }

  const pathname = window.location.pathname
    .replace(/\/index\.html$/, '')
    .replace(/\/+$/, '')

  return `${window.location.origin}${pathname}`
}

export const buildFrontendHashUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${getFrontendBaseUrl()}#${normalizedPath}`
}
